import apiClient from './apiClient'


const getNotifications = (skip, take, search, chainId, sortBy, sortOrder) => {
  const params = { skip, take, search, sortBy, sortOrder }
  return apiClient.get(`/Notification/${chainId}`, { params })
}

const getNotificationsByDealer = (dealerId, skip, take, search, sortBy, sortOrder) => {
  const params = { skip, take, search, sortBy, sortOrder }
  return apiClient.get(`/Notification/dealer/${dealerId}`, { params })
}

const getNotificationsByVehicle = (vehicleId) => {
  return apiClient.get(`/Notification/Vehicle/${vehicleId}`)
}

const sendNotificationReminders = (vehicleIds) => {
  return apiClient.put('/Template/Reminder', vehicleIds)
}



export default {
  getNotifications,
  getNotificationsByDealer,
  getNotificationsByVehicle,
  sendNotificationReminders
}
